import { render, staticRenderFns } from "./MainDashboardPage.vue?vue&type=template&id=1cb91a16&"
import script from "./MainDashboardPage.vue?vue&type=script&lang=js&"
export * from "./MainDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports